import SignIn from '@/views/SignIn.vue'
import LoginForm from '@/components/identity/LoginForm.vue'
import IdentityForm from '@/components/identity/IdentityForm.vue'
import RegisterForm from '@/components/identity/RegisterForm.vue'
import ForgotPasswordForm from '@/components/identity/ForgotPasswordForm.vue'
import {permissions} from '@/enums'
import store from '@/store'
import Savings from '@/components/savings/Savings.vue'

const defaultLocale = 'de'
const allowedLocale = `/:locale(${defaultLocale})?`

export const routes = [
  {
    path: allowedLocale,
    name: 'homepage',
    redirect: {name: 'defaultSignIn'}
  },
  {
    path: allowedLocale + '/signin',
    component: SignIn,
    children: [
      {
        path: '',
        name: 'defaultSignIn',
        component: LoginForm,
      },
      {
        path: 'login',
        name: 'login',
        component: LoginForm
      },
      {
        path: 'identity',
        name: 'identity',
        component: IdentityForm
      },
      {
        path: 'register',
        name: 'register',
        component: RegisterForm,
        children: [
          {
            path: 'thank-you',
            name: 'thankYou',
            component: () => import('../components/common/ThankYou.vue')
          }
        ]
      },
      {
        path: 'forgotPassword',
        name: 'forgotPassword',
        component: ForgotPasswordForm
      }
    ]
  },
  {
    path: allowedLocale + '/dashboard',
    name: 'dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Dashboard.vue'),
    meta: {requiresAuth: true, requiresPermission: permissions.Output}
  },
  {
    path: allowedLocale + '/upload',
    name: 'upload',
    component: () => import('../views/Upload.vue'),
    meta: {requiresAuth: true, requiresPermission: permissions.Output}
  },
  {
    path: allowedLocale + '/upload/:orderId?/:step?',
    name: 'uploadParams',
    component: () => import('../views/Upload.vue'),
    meta: {requiresAuth: true, requiresPermission: permissions.Output}
  },
  {
    path: allowedLocale + '/testupload',
    name: 'testUpload',
    component: () => import('../views/Upload.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: allowedLocale + '/testupload/:orderId?/:step?',
    name: 'testUploadParams',
    component: () => import('../views/Upload.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: allowedLocale + '/orders/:viewName(list|documents)?',
    props: route => {
      let viewName = String(route.params.viewName)
      if (viewName === 'undefined') viewName = 'list'
      return {viewName}
    },
    name: 'orders',
    component: () => import('../views/Orders.vue'),
    meta: {requiresAuth: true, requiresPermission: permissions.Output}
  },
  {
    path: allowedLocale + '/inbox',
    name: 'inbox',
    component: () => import('../views/Inbox.vue'),
    meta: {requiresAuth: true, requiresPermission: permissions.Input}
  },
  // LEGACY ROUTE
  // @TODO: remove once confirmed
  // {
  //   path: allowedLocale + '/profil',
  //   name: 'profil',
  //   component: () => import('../views/Profil.vue'),
  //   beforeEnter: (to, from, next) => {
  //     // set default route to /contact
  //     next(to.fullPath + '/contact')
  //   },
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path:
  //     allowedLocale +
  //     '/profil/:tabName(generally|contact|accountManagement|uploadServices|credit|printParameters)',
  //   props: route => {
  //     const tabName = String(route.params.tabName)
  //     return { tabName }
  //   },
  //   name: 'profilParams',
  //   component: () => import('../views/Profil.vue'),
  //   meta: {
  //     requiresAuth: true,
  //     requiresPermission: [
  //       {
  //         permission: permissions.CreditAccount,
  //         routeName: 'credit',
  //         paramName: 'tabName'
  //       }
  //     ]
  //   }
  // },
  {
    path: allowedLocale + '/profile',
    name: 'profile',
    component: () => import('../views/UserProfile.vue'),
    beforeEnter: (to, from, next) => {
      // set default route to /contact
      next(to.fullPath + '/contact')
    },
    meta: {requiresAuth: true}
  },
  {
    path:
      allowedLocale +
      '/profile/:tabName(general|contact|avv)',
    props: route => {
      const tabName = String(route.params.tabName)
      return {tabName}
    },
    name: 'profilParams',
    component: () => import('../views/UserProfile.vue'),
    meta: {
      requiresAuth: true,
      requiresPermission: [
        {
          permission: permissions.CreditAccount,
          routeName: 'credit',
          paramName: 'tabName'
        }
      ]
    }
  },
  {
    path: allowedLocale + '/settings',
    name: 'settings',
    component: () => import('../views/Settings.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: allowedLocale + '/my-organizations',
    name: 'my-organizations',
    component: () => import('../views/MyOrganizations.vue'),
    isAdmin: () => store?.getters?.isAdminInAnyOrganization,
    meta: {requiresAuth: true, requiresPermission: permissions.Invite}
  },
  {
    path: allowedLocale + '/reseller-management',
    name: 'reseller-management',
    component: () => import('../views/ResellerManagement.vue'),
    isAdmin: () => store?.getters?.isAdminInAnyOrganization,
    meta: {requiresAuth: true, requiresPermission: permissions.ResellerManagement}
  },
  {
    path: allowedLocale + '/avv',
    name: 'avv',
    component: () => import('../views/AvvView.vue'),
    meta: {requiresAuth: false}
  },
  {
    path: allowedLocale + '/agb',
    name: 'agb',
    component: () => import('../views/AgbView.vue'),
    meta: {requiresAuth: false}
  },
  {
    path: allowedLocale + '/faq',
    name: 'faq',
    component: () => import('../views/Faq.vue'),
    meta: {requiresAuth: false}
  },
  {
    path: allowedLocale + '/changelog',
    name: 'changelog',
    component: () => import('../views/Changelog.vue'),
    meta: {requiresAuth: false}
  },
  {
    path: allowedLocale + '/registrationconfirmation/:token(.*)/:userEmail',
    name: 'registrationconfirmation',
    component: () => import('../views/RegistrationConfirmation.vue'),
    meta: {requiresAuth: false}
  },
  {
    path: allowedLocale + '/confirmEmailChange/:token(.*)/:userEmail/:userId',
    name: 'confirmemailchange',
    component: () => import('../views/ConfirmEmailChange.vue'),
    meta: {requiresAuth: false}
  },
  {
    path: allowedLocale + '/invitation/:token',
    name: 'invitation',
    component: () => import('../views/Invitation.vue'),
    meta: {requiresAuth: false}
  },
  {
    path: allowedLocale + '/voucher',
    name: 'voucher',
    component: () => import('../components/credit/voucher/Voucher.vue'),
    meta: {requiresAuth: false}
  },
  {
    path: allowedLocale + '/resetpassword/:token(.*)/:userEmail',
    name: 'resetpassword',
    props: true,
    component: () => import('../views/ResetPassword.vue'),
    meta: {requiresAuth: false}
  },
  {
    path: allowedLocale + '/migration/:userData(.*)',
    name: 'migration',
    component: () => import('../components/migration/Migration.vue'),
    meta: {requiresAuth: false}
  },
  {
    path: allowedLocale + '/backoffice',
    name: 'backoffice',
    component: () => import('../views/Backoffice.vue'),
    meta: {
      requiresAuth: true,
      requiresPermission: permissions.Backoffice
    }
  },
  {
    path: allowedLocale + '/logout',
    name: 'logout',
    component: () => import('../views/Logout.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: allowedLocale + '/404',
    component: () => import('../views/PageNotFound.vue')
  },
  {
    path: '*',
    redirect: store && store.getters ? store.getters.locale + '/404' : allowedLocale + '/404'
  },
  {
    path: allowedLocale + '/invoices',
    name: 'invoices',
    component: () => import('../views/Invoices.vue'),
    meta: {
      requiresAuth: true,
      requiresPermission: permissions.hasCreditAccount
    }
  },
  {
    path: allowedLocale + '/testletter',
    name: 'testletter',
    component: () => import('../views/Testletter.vue'),
  },
  {
    path: allowedLocale + '/savings',
    name: 'savings',
    component: Savings,
    meta: {requiresAuth: false}
  }
]
